import React, { useEffect, useState } from 'react'
import Plot from 'react-plotly.js';
import styles from '../MileageAnalysisTab_bus/MileageAnalysisTab_bus.module.css'
import { Info } from 'lucide-react'
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';

// import CustomPopover from './Popover';

function ModalBarChart({ data, filterdata }) {
  const { label, barName } = data
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [tooltipData, setTooltipData] = useState({
    relevant: 0,
    zeroValue: 0
  })

  const [graphData, setGraphData] = useState([])
  const [benchmark, setBenchMark] = useState({
    currentValue: "",
    stdValue: ""
  })

  useEffect(() => {

    let ApiUrl = "";
    let stdValue = 0
    if (barName === "Speed") {

      ApiUrl = "simulator_Speed_graph_and_i_button"

      stdValue = 25
    } else if (barName === "AccPedal") {
      ApiUrl = "simulator_Accelarator_Pedal_graph_and_i_button"


      stdValue = 24
    } else if (barName === "MotorRPM") {

      ApiUrl = "simulator_RPM_graph_and_i_button"

      stdValue = 13

    } else {
      ApiUrl = "";
    }

    setBenchMark(prev => ({ ...prev, stdValue }))


    if (!ApiUrl) {
      return
    }

    fetchData(
      {
        url: API_URL_MAIN + `simulator/${ApiUrl}`,
        body: {
          filterdata: {
            ...filterdata,
            // "VIN_NUM": vinNo,
          }
        }
      },
      (res) => {
        const resData = res[0]
        let barData
        let currentValue = 0
        if (barName == "Speed") {
          barData = [
            { range: '0-20', value: Number(resData?.Speed_0_20?.value) || 0 },
            { range: '20-30', value: Number(resData?.Speed_20_30?.value) || 0 },
            { range: '30-50', value: Number(resData?.Speed_30_50?.value) || 0, target: 25 },
            { range: '50-60', value: Number(resData?.Speed_50_60?.value) || 0 },
            { range: '60+', value: Number(resData?.["Speed_60+"]?.value) || 0 }
          ]
          currentValue = Number(resData?.Speed_30_50?.value)
          setTooltipData(prev => ({ ...prev, relevant: Number(resData?.Speed_Relevant?.value) || 0 }))

        }
        if (barName == "AccPedal") {
          // barData = [
          //   { range: '0-20', value: resData?.["Accelarator Pedal_0_20"]?.value || 0 },
          //   { range: '20-40', value: resData?.["Accelarator Pedal_20_40"]?.value || 0, target: 24 },
          //   { range: '40-60', value: resData?.["Accelarator Pedal_40_60"]?.value || 0 },
          //   { range: '60+', value: resData?.["Accelarator Pedal_60+"]?.value || 0 }
          // ]

          barData = [
            { range: '0-20', value: resData?.["Accelarator Pedal_0_20"]?.value || 0 },
            { range: '20-30', value: resData?.["Accelarator Pedal_20_30"]?.value || 0, target: 24 },
            { range: '30-50', value: resData?.["Accelarator Pedal_30_50"]?.value || 0 },
            { range: '50-60', value: resData?.["Accelarator Pedal_50_60"]?.value || 0 },
            { range: '60+', value: resData?.["Accelarator Pedal_60+"]?.value || 0 }
          ]

          currentValue = Number(resData?.["Accelarator Pedal_20_30"]?.value)
          setTooltipData(prev => ({ ...prev, relevant: Number(resData?.AccPed_Relevant?.value) || 0 }))
        }

        if (barName == "MotorRPM") {
          barData = [
            { range: '0-1000', value: resData?.["RPM_0_1000"]?.value || 0 },
            { range: '1000-2000', value: resData?.["RPM_1000_2000"]?.value || 0, target: 13 },
            { range: '2000-3000', value: resData?.["RPM_2000_3000"]?.value || 0 },
            { range: '3000-4000', value: resData?.["RPM_3000_4000"]?.value || 0 },
            { range: '4000+', value: resData?.["RPM_4000_plus"]?.value || 0 }
          ]

          currentValue = Number(resData?.["RPM_1000_2000"]?.value)
          setTooltipData(prev => ({ ...prev, relevant: Number(resData?.RPM_Relevant?.value) || 0 }))

        }
        setGraphData(barData)
        setBenchMark(prev => ({ ...prev, currentValue }))
      }
    );

  }, [barName, filterdata])


  // function handlePopoverOpen() {
  //   setTooltipData({
  //     relevant: 0,
  //     zeroValue: 0
  //   })

  //   let ApiUrl = "";

  //   if (barName === "vehicleSpeedDistribution") {
  //     ApiUrl = vehicleType === "primary" ? "mileage_analysis_vehicle_speed_distribution_custom" :
  //       vehicleType === "best" ? "mileage_analysis_vehicle_speed_distribution_best" :
  //         vehicleType === "secondary" ? "mileage_analysis_vehicle_speed_distribution_custom" :
  //           vehicleType === "National" ? "mileage_analysis_national_vehicle_speed" :
  //             vehicleType == "Depo" ? "mileage_analysis_depo_vehicle_speed" : ""


  //   } else if (barName === "accPedalPosition") {

  //     ApiUrl = vehicleType === "primary" ? "mileage_analysis_accelaration_pedal_custom" :
  //       vehicleType === "best" ? "mileage_analysis_accelaration_pedal_best" :
  //         vehicleType === "secondary" ? "mileage_analysis_accelaration_pedal_custom" :
  //           vehicleType === "National" ? "mileage_analysis_national_accelarator_pedal" :
  //             vehicleType == "Depo" ? "mileage_analysis_depo_accelarator_pedal" : ""

  //   } else if (barName === "RPM") {

  //     ApiUrl = vehicleType === "primary" ? "mileage_analysis_rpm_Relevant_custom" :
  //       vehicleType === "best" ? "mileage_analysis_rpm_Relevant_best" :
  //         vehicleType === "secondary" ? "mileage_analysis_rpm_Relevant_custom" :
  //           vehicleType === "National" ? "mileage_analysis_national_rpm_Relevant" :
  //             vehicleType == "Depo" ? "mileage_analysis_depo_rpm_Relevant" : ""


  //   } else {
  //     ApiUrl = "";
  //   }

  //   let filterData = vehicleType === "secondary" ? customFilter : globalFilter
  //   let vinNo = []
  //   if (ApiUrl) {
  //     vinNo = vehicleType === "primary" ? [firstVinNo?.vehicleId] :
  //       vehicleType === "best" ? [firstVinNo?.vehicleId] :
  //         vehicleType === "secondary" ? [secondVinNo?.vehicleId] :
  //           vehicleType === "National" ? [GlobalData?.nationalVehicleId] :
  //             vehicleType == "Depo" ? [GlobalData?.bestDepoVehicleId] : []

  //   }

  //   fetchData(
  //     {
  //       url: API_URL_MAIN + `mileage_analysis/${ApiUrl}`,
  //       body: {
  //         filterdata: {
  //           ...filterData,
  //           "VIN_NUM": vinNo,
  //         }
  //       }
  //     },
  //     (res) => {
  //       let data = res[0]
  //       setTooltipData(prev => ({
  //         ...prev,
  //         relevant: data?.relevantValue?.value?.toFixed(2),
  //         zeroValue: 0

  //       }))
  //     }
  //   );
  // }


  const renderPopover = (
    <Popover
      className={styles.custom_popover_width}
    >
      <Popover.Body>
        <div className="container-fluid p-0">
          <div className="row" style={{ height: '40px' }}>

            {/* Left Section - 4 columns */}
            <div className="col-5 pe-0 ps-2">
              <small style={{ color: "#0d3f70" }}>{tooltipData?.relevant?.toFixed(2)}%</small><br />
              <span className="fw-6" style={{ fontSize: "10px" }}>{label} Relevant</span>
            </div>

            {/* Divider - 2 columns */}
            <div className="col-1 d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
              <div
                style={{
                  width: '1.3px',
                  height: '60%',
                  backgroundColor: '#cddaea',
                }}
              ></div>
            </div>

            {/* Right Section - 4 columns */}
            <div className="col-5 px-0">
              <small style={{ color: "#0d3f70" }}>{tooltipData?.zeroValue}%</small> <br />
              <span style={{ fontSize: "10px" }}>{label} 0</span>
            </div>

          </div>
        </div>
      </Popover.Body>
    </Popover>
  );




  return (
    <div>
      <div id="modalBarChart_MSbus_Stimulator" className="modal fade" role="dialog">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-capitalize">{label}</h5>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body p-0" style={{ overflowY: "scroll", height: "380px", }}>
              <div className="row mb-3 col-12" style={{ margin: '2px -5px 0 -5px', marginLeft: 'auto', marginRight: 'auto' }}> {/* Reduced top margin from 5px to 2px and constrained width */}
                <div className="col-6" style={{ padding: '0 5px' }}>
                  <div className={styles.summaryCard}>
                    <div className={styles.summaryCardLabel} style={{
                      fontSize: '10px',
                      lineHeight: '1.2',
                      minHeight: '32px',
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      Actual {label} Contribution
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <span className='fw-bolder' style={{ fontSize: '14px', color: benchmark.currentValue >= benchmark.stdValue ? '#00b050' : '#c91104' }}>
                        {Number(benchmark?.currentValue)?.toFixed(2)}%
                      </span>
                      <span style={{ fontSize: '14px', color: '#d9a404' }}>
                        {benchmark.currentValue >= benchmark.stdValue ? '▲' : '▼'}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-6" style={{ padding: '0 5px' }}>
                  <div className={styles.summaryCard}>
                    <div className={styles.summaryCardLabel} style={{
                      fontSize: '10px',
                      lineHeight: '1.2',
                      minHeight: '32px',
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      Potential {label} Contribution Following Benchmark
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <span className={styles.bestValueText} style={{ fontSize: '14px' }}>
                        {Number(benchmark?.stdValue)?.toFixed(2)}%
                      </span>
                      <span style={{ fontSize: '14px', color: '#d9a404' }}> ▲</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="position-relative">
                <div className="d-flex justify-content-end px-3 mb-1">
                  <span >
                    <OverlayTrigger
                      trigger="click"
                      placement="bottom-end"
                      overlay={renderPopover}
                      // onEnter={handlePopoverOpen}
                      rootClose
                    >
                      <Info
                        size={16}
                        style={{ color: '#83a4cf', cursor: 'pointer' }}
                      />
                    </OverlayTrigger>
                  </span>
                </div>
                <div className='d-flex justify-content-center'>
                  {
                    graphData?.length > 0 ?
                      <CustomPlotlyBarChart data={graphData} benchmark={benchmark} />
                      : <></>
                  }
                </div>
                <div className="small text-muted mb-4 mt-0">
                  Speed 0 and Speed NA are non-actionable buckets, hence not represented in the graph
                </div>
              </div>
              <div className="modal-footer p-2">
                <button type="button" className="btn ms_btn btn-default MS_button" data-dismiss="modal" >
                  CLOSE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div >
    </div>
  )
}

export default ModalBarChart




const CustomPlotlyBarChart = ({ data, benchmark }) => {
  const xLabels = data.map(d => d.range);
  const yValues = data.map(d => d.value);

  const targetIndex = data.findIndex(d => d.target !== undefined && d.target !== null);
  const targetBar = data[targetIndex];

  const barColors = data.map((d, i) => (i === targetIndex ? (benchmark.currentValue >= benchmark.stdValue ? '#00b050' : '#c91104') : '#d9d9d9'));

  const annotations = [];
  const shapes = [];

  if (targetBar) {
    const xPos = targetBar.range;
    const yPos = targetBar.value;
    const isTargetBelow = targetBar.value > targetBar.target;
    const triangleColor = isTargetBelow ? '#00b050' : '#ffc000';
    const triangleDirection = !isTargetBelow ? 'up' : 'down';

    const trianglePath =
      triangleDirection === 'up'
        ? 'M 0 10 L 5 0 L 10 10 Z'
        : 'M 0 0 L 5 10 L 10 0 Z';

    shapes.push({
      type: 'path',
      path: trianglePath,
      xref: 'x',
      yref: 'y',
      xsizemode: 'pixel',
      ysizemode: 'pixel',
      xanchor: xPos,
      yanchor: yPos + 5,
      xshift: -5,
      line: { width: 0 },
      fillcolor: triangleColor,
    });

    shapes.push({
      type: 'line',
      x0: xPos,
      x1: xPos,
      y0: targetBar.target,
      y1: targetBar.target,
      line: {
        color: '#000',
        width: 1,
        dash: 'dot',
      },
    });

    const labelMargin = 14;

    annotations.push({
      x: xPos,
      y: yPos + labelMargin + 6,
      text: `${targetBar.target.toFixed(2)}%`,
      showarrow: false,
      font: { color: '#002060', size: 10, family: 'Arial', weight: 'bold' },
      yshift: 0,
    });

    annotations.push({
      x: xPos,
      y: yPos + labelMargin,
      text: `${targetBar.value.toFixed(2)}%`,
      showarrow: false,
      font: { color: triangleColor, size: 10, family: 'Arial', weight: 'bold' },
      yshift: 0,
    });
  }

  // Add labels for all non-target bars
  data.forEach((d, index) => {
    if (index !== targetIndex) {
      annotations.push({
        x: d.range,
        y: d.value + 14,
        text: `${d.value.toFixed(2)}%`,
        showarrow: false,
        font: {
          color: '#595959',
          size: 10,
          family: 'Arial',
        },
        yshift: 0,
      });
    }
  });

  return (
    <Plot
      data={[
        {
          x: xLabels,
          y: yValues,
          type: 'bar',
          marker: {
            color: barColors,
          },
          hovertemplate: '%{y:.2f}%',
        },
      ]}
      layout={{
        height: 230,
        width: 420,
        margin: { t: 10, r: 20, l: 40, b: 20 },
        xaxis: {
          title: '',
          tickfont: { size: 10 },
        },
        yaxis: {
          title: {
            text: 'Duration %',
            font: { size: 10 },
            standoff: 10,
          },
          range: [0, 100],
          ticksuffix: '%',
          tickfont: { size: 10 },
          showline: true,
          linecolor: '#000',
          linewidth: 1,
        },
        annotations: annotations,
        shapes: shapes,
        bargap: 0.4,
        plot_bgcolor: '#fff',
        paper_bgcolor: '#fff',
        showlegend: false,
      }}
      config={{
        responsive: true,
        displayModeBar: false,
        staticPlot: true,
      }}
    />
  );
};












// import React from 'react';
// import Plot from 'react-plotly.js';
// import styles from '../MileageAnalysisTab_bus/MileageAnalysisTab_bus.module.css';
// import { Info } from 'lucide-react';

// const ModalBarChart_Params = ({ show, onClose, label, defaultValue, benchmarkValue }) => {
//   if (!show) return null;

//   const graphData = [
//     { range: '0-20', value: 8.5 },
//     { range: '20-30', value: 15.2 },
//     { range: '30-50', value: 32.15, target: benchmarkValue },
//     { range: '50-60', value: 25.75 },
//     { range: '60+', value: 18.4 }
//   ];

//   const benchmark = {
//     currentValue: defaultValue,
//     stdValue: benchmarkValue
//   };

//   return (
//     <div className="modal d-block" tabIndex="-1" role="dialog">
//       <div className="modal-dialog modal-md">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title text-capitalize">{label}</h5>
//             <button type="button" className="btn-close" onClick={onClose}></button>
//           </div>
//           <div className="modal-body p-0" style={{ overflowY: "scroll", height: "380px" }}>
//             <div className="row mb-3 col-12" style={{ margin: '2px -5px 0 -5px', marginLeft: 'auto', marginRight: 'auto' }}>
//               <div className="col-6" style={{ padding: '0 5px' }}>
//                 <div className={styles.summaryCard}>
//                   <div className={styles.summaryCardLabel} style={{ fontSize: '10px', lineHeight: '1.2', minHeight: '32px', display: 'flex', alignItems: 'center' }}>
//                     Actual {label} Contribution
//                   </div>
//                   <div className="d-flex align-items-center justify-content-center">
//                     <span className='fw-bolder' style={{ fontSize: '14px', color: benchmark.currentValue >= benchmark.stdValue ? '#00b050' : '#c91104' }}>
//                       {Number(benchmark?.currentValue)?.toFixed(2)}%
//                     </span>
//                     <span style={{ fontSize: '14px', color: '#d9a404' }}>
//                       {benchmark.currentValue >= benchmark.stdValue ? '▲' : '▼'}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-6" style={{ padding: '0 5px' }}>
//                 <div className={styles.summaryCard}>
//                   <div className={styles.summaryCardLabel} style={{ fontSize: '10px', lineHeight: '1.2', minHeight: '32px', display: 'flex', alignItems: 'center' }}>
//                     Potential {label} Contribution Following Benchmark
//                   </div>
//                   <div className="d-flex align-items-center justify-content-center">
//                     <span className={styles.bestValueText} style={{ fontSize: '14px' }}>
//                       {Number(benchmark?.stdValue)?.toFixed(2)}%
//                     </span>
//                     <span style={{ fontSize: '14px', color: '#d9a404' }}> ▲</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="position-relative">
//               <div className="d-flex justify-content-end px-3 mb-1">
//                 <span title="This chart shows how different ranges contribute to the overall value.">
//                   <Info size={16} style={{ color: '#83a4cf', cursor: 'pointer' }} />
//                 </span>
//               </div>
//               <div className='d-flex justify-content-center'>
//                 <CustomPlotlyBarChart_Params data={graphData} benchmark={benchmark} />
//               </div>
//               <div className="small text-muted mb-4 mt-0">
//                 Speed 0 and Speed NA are non-actionable buckets, hence not represented in the graph
//               </div>
//             </div>
//             <div className="modal-footer p-2">
//               <button type="button" className="btn ms_btn btn-default MS_button" onClick={onClose}>
//                 CLOSE
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const CustomPlotlyBarChart_Params = ({ data, benchmark }) => {
//   const xLabels = data.map(d => d.range);
//   const yValues = data.map(d => d.value);

//   const targetIndex = data.findIndex(d => d.target !== undefined);
//   const targetBar = data[targetIndex];

//   const barColors = data.map((d, i) => i === targetIndex ? (benchmark.currentValue >= benchmark.stdValue ? '#00b050' : '#c91104') : '#d9d9d9');

//   const annotations = [];
//   const shapes = [];

//   if (targetBar) {
//     const xPos = targetBar.range;
//     const yPos = targetBar.value;
//     const isTargetBelow = yPos > targetBar.target;
//     const triangleColor = isTargetBelow ? '#00b050' : '#ffc000';
//     const triangleDirection = !isTargetBelow ? 'up' : 'down';

//     const trianglePath =
//       triangleDirection === 'up'
//         ? 'M 0 10 L 5 0 L 10 10 Z'
//         : 'M 0 0 L 5 10 L 10 0 Z';

//     shapes.push({
//       type: 'path',
//       path: trianglePath,
//       xref: 'x',
//       yref: 'y',
//       xsizemode: 'pixel',
//       ysizemode: 'pixel',
//       xanchor: xPos,
//       yanchor: yPos + 5,
//       xshift: -5,
//       line: { width: 0 },
//       fillcolor: triangleColor,
//     });

//     shapes.push({
//       type: 'line',
//       x0: xPos,
//       x1: xPos,
//       y0: targetBar.target,
//       y1: targetBar.target,
//       line: {
//         color: '#000',
//         width: 1,
//         dash: 'dot',
//       },
//     });

//     annotations.push({
//       x: xPos,
//       y: yPos + 20,
//       text: `${targetBar.target.toFixed(2)}%`,
//       showarrow: false,
//       font: { color: '#002060', size: 10, family: 'Arial' },
//     });

//     annotations.push({
//       x: xPos,
//       y: yPos + 14,
//       text: `${targetBar.value.toFixed(2)}%`,
//       showarrow: false,
//       font: { color: triangleColor, size: 10, family: 'Arial' },
//     });
//   }

//   data.forEach((d, index) => {
//     if (index !== targetIndex) {
//       annotations.push({
//         x: d.range,
//         y: d.value + 14,
//         text: `${d.value.toFixed(2)}%`,
//         showarrow: false,
//         font: {
//           color: '#595959',
//           size: 10,
//           family: 'Arial',
//         },
//       });
//     }
//   });

//   return (
//     <Plot
//       data={[{
//         x: xLabels,
//         y: yValues,
//         type: 'bar',
//         marker: { color: barColors },
//         hovertemplate: '%{y:.2f}%'
//       }]}
//       layout={{
//         height: 230,
//         width: 420,
//         margin: { t: 10, r: 20, l: 40, b: 20 },
//         xaxis: { tickfont: { size: 10 } },
//         yaxis: {
//           title: { text: 'Duration %', font: { size: 10 }, standoff: 10 },
//           range: [0, 100],
//           ticksuffix: '%',
//           tickfont: { size: 10 },
//           showline: true,
//           linecolor: '#000',
//           linewidth: 1,
//         },
//         annotations: annotations,
//         shapes: shapes,
//         bargap: 0.4,
//         plot_bgcolor: '#fff',
//         paper_bgcolor: '#fff',
//         showlegend: false,
//       }}
//       config={{
//         responsive: true,
//         displayModeBar: false,
//         staticPlot: true,
//       }}
//     />
//   );
// };

// export default ModalBarChart_Params;